import {SavedSearchRule} from './types';

export const validateSavedSearchRule = <
	T extends SavedSearchRule = SavedSearchRule,
>(
	rule: T,
) => {
	return true;
};

export default validateSavedSearchRule;
